export const MARKETING = 'MARKETING'
